import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { CommonModule } from '@modules/common/common.module';
import { SharedBaseComponent } from '@modules/common/components/shared-base/shared-base.component';
import { DateFormatPipe } from '@modules/common/pipes/date-format.pipe';
import { SharedKnotsComponent } from '@modules/knots/components/shared-knots/shared-knots.component';
import { SharedSignupCtaComponent } from '@modules/common/components/shared-signup-cta/shared-signup-cta.component';
import { MailBodyComponent } from '@modules/mail/components/mail-body/mail-body.component';
import { MailAppContextDirective } from '@modules/messages/directives/app-mail-app-context.directive';
import { Message } from '@modules/messages/types/message';
import { KnowledgePanelService } from '@modules/knowledge/services/knowledge-panel.service';
import { SharedTagsComponent } from '@modules/tags/components/shared-tags/shared-tags.component';
import { StitchType } from '@sharedlib/common/types/StitchType';

@Component({
  selector: 'stch-message-shared',
  templateUrl: './message-shared.component.html',
  styleUrls: ['../../../common/components/shared-base/shared-base.component.less'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MailAppContextDirective,
    DateFormatPipe,
    CommonModule,
    SharedTagsComponent,
    SharedKnotsComponent,
    SharedSignupCtaComponent,
    MailBodyComponent,
  ],
})
export class MessageSharedComponent extends SharedBaseComponent<Message> {
  protected override readonly stitchType = StitchType.MESSAGE;

  /** The selected knots' names, highlighted inside the mail's frame (the page's CSS highlights cannot reach it). */
  protected readonly highlights = toSignal(
    inject(KnowledgePanelService)
      .getSelectedKnots()
      .pipe(map((knots) => knots.map((knot) => knot.name))),
    { initialValue: [] },
  );

  protected get message(): Message {
    return this.stitchItem?.();
  }
}
